import { useMemo } from 'react';
import { useAppSelector } from '../../../app/hooks';

export const useUserDateTime = () => {
  const { date_format, twenty_four_hour_time, timezone } =
    useAppSelector((state) => state.auth?.user) || {};
  return useMemo(
    () => ({
      dateFormat: date_format ? date_format : 'M/d/yyyy',
      dateFormatWithZeros:
        date_format === 'd/M/yyyy'
          ? 'dd/MM/yyyy'
          : date_format === 'M/d/yyyy' || !date_format
          ? 'MM/dd/yyyy'
          : 'yyyy/MM/dd',
      timeFormat: twenty_four_hour_time ? 'HH:mm:ss' : 'hh:mm:ss aa',
      timeFormatNoSeconds: twenty_four_hour_time ? 'HH:mm' : 'hh:mm aa',
      timeFormatHoursOnly: twenty_four_hour_time ? 'HH' : 'hh',
      timeFormatHoursOnlyWithAMPM: twenty_four_hour_time ? 'HH:mm' : 'h aa',
      monthDayFormat: date_format === 'd/M/yyyy' ? 'd-M' : 'M-d',
      monthAbbreviatedWordDayFormat:
        date_format === 'd/M/yyyy' ? 'd MMM' : 'MMM d',
      monthAbbreviatedWordDayFormatWithYear:
        date_format === 'd/M/yyyy' ? 'd MMM yyyy' : 'MMM d, yyyy',
      ampm: !twenty_four_hour_time,
      timezone:
        !timezone || timezone === 'Local'
          ? Intl.DateTimeFormat().resolvedOptions().timeZone
          : 'Etc/UTC',
      browserTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      getCurrentDateTime: () => {
        const currentDate = new Date();
        if (timezone === 'Local' || !timezone) {
          return currentDate;
        }
        return new Date(
          currentDate.getTime() + currentDate.getTimezoneOffset() * 60000
        );
      },
    }),
    [date_format, twenty_four_hour_time, timezone]
  );
};
